export default __webpack_public_path__ + "static/writer-3-3785c30cd764502cb161e279bfa77e6c.png";